import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import "./HomepageButton.css";

function cx(...values) {
  return values.filter(Boolean).join(" ");
}

const variantClassMap = {
  primary: "homepage-button--primary",
  outline: "homepage-button--outline",
  ghost: "homepage-button--ghost",
};

const HomepageButton = forwardRef(
  (
    {
      as: Comp = "button",
      children,
      className,
      leftIcon,
      rightIcon,
      variant = "primary",
      fullWidth = false,
      pill = false,
      isActive,
      type = "button",
      ...rest
    },
    ref
  ) => {
    const classes = cx(
      "homepage-button",
      variantClassMap[variant] || variantClassMap.primary,
      fullWidth && "homepage-button--full-width",
      pill && "homepage-button--pill",
      className
    );
    const isButtonElement = Comp === "button";

    return (
      <Comp
        ref={ref}
        className={classes}
        {...(isButtonElement ? { type } : {})}
        aria-pressed={typeof isActive === "boolean" ? isActive : undefined}
        {...rest}
      >
        {leftIcon && (
          <span className="homepage-button__icon homepage-button__icon--left">{leftIcon}</span>
        )}
        <span className="homepage-button__label">{children}</span>
        {rightIcon && (
          <span className="homepage-button__icon homepage-button__icon--right">{rightIcon}</span>
        )}
      </Comp>
    );
  }
);

HomepageButton.displayName = "HomepageButton";

HomepageButton.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  fullWidth: PropTypes.bool,
  pill: PropTypes.bool,
  variant: PropTypes.oneOf(["primary", "outline", "ghost"]),
  isActive: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default HomepageButton;
